import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
const PlatformContext = React.createContext({
    isIos: false,
    isAndroid: false,
    isTouch: false,
    isMobileApp: false,
    isMobile: false,
    locale: null,
    // On web, microphone permission is handled by the browser via getUserMedia — always return true
    requestMicrophonePermission: async () => true,
});
export const PlatformContextProvider = ({ isIos, isAndroid, isTouch, isMobileApp, isMobile, locale, requestMicrophonePermission, children, }) => {
    const value = React.useMemo(() => ({ isIos, isAndroid, isTouch, isMobileApp, isMobile, locale, requestMicrophonePermission }), [isIos, isAndroid, isTouch, isMobileApp, isMobile, locale, requestMicrophonePermission]);
    return _jsx(PlatformContext, { value: value, children: children });
};
export const usePlatform = () => React.use(PlatformContext);
